import template from './leave_earned_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveEarnedHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveEarnedHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveEarnedHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveEarnedHelp',
	dialog_class: LeaveEarnedHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_earned_help',
	provider: 'ps'
};
